import styled, { css } from 'styled-components';

import { ThemeProps as Prop, Breakpoints, Components } from '@powdr/constants';
import { themeUtil } from '@powdr/utils';

const CPNT = Components.RATES_AND_DATES_SWITCHER;

export const StyledRatesAndDatesSwitcher = styled.div`

`;

export const Selectors = styled.ul`
  display: flex;
  margin-bottom: 25px;

  li {
    list-style: none;
  }

  li:not(:last-child) button {
    border-right: none;
  }
`;

export const Selector = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  background-color: ${({ $active, $colorProfile }) => (($active)
    ? themeUtil(Prop.BTN_BG_ACTIVE, CPNT, $colorProfile)
    : themeUtil(Prop.BACKGROUND, CPNT, $colorProfile))};

  color: ${({ $active, $colorProfile }) => (($active)
    ? themeUtil(Prop.BTN_TXT_ACTIVE, CPNT, $colorProfile)
    : themeUtil(Prop.CONTENT, CPNT, $colorProfile))};

  border: 1px solid ${({ $active, $colorProfile }) => (($active)
    ? themeUtil(Prop.BTN_TXT_ACTIVE, CPNT, $colorProfile)
    : themeUtil(Prop.CONTENT, CPNT, $colorProfile))};

  min-width: 125px;
  padding: 8px 10px;

  .selector-icon {
    margin-right: 3px;

    svg {
      color: ${({ $colorProfile }) => themeUtil(Prop.CONTENT, CPNT, $colorProfile)};
      fill: ${({ $colorProfile }) => themeUtil(Prop.CONTENT, CPNT, $colorProfile)};
    }
  }
`;

export const ActiveRDContainer = styled.div`

`;
